import { isValidCPF, onlyNumbersMask } from './stringUtil'
import { getDiffTime, isValidDate } from './timeUtil'

export const validateBeneficiaryFields = {
  name: verifyName,
  cpf: verifyCpf,
  birthdate: verifyBirthdate,
  insuranceNumber: verifyInsuranceNumber,
  email: verifyEmail,
  phoneNumber: verifyPhoneNumber,
}

export const validateBeneficiary = ({
  name,
  cpf,
  birthdate,
}) => {
  if (verifyName(name)) return true
  if (verifyCpf(cpf)) return true
  if (verifyBirthdate(birthdate)) return true
  return false
}

export const validateUser = ({
  name,
  cpf,
  birthdate,
  email,
  phoneNumber,
  insuranceNumber,
  sex,
}) => {
  if (verifyName(name)) return true
  if (verifyCpf(cpf)) return true
  if (verifyBirthdate(birthdate)) return true
  if (verifyInsuranceNumber(onlyNumbersMask(insuranceNumber))) return true
  if (verifyEmail(email)) return true
  if (verifyPhoneNumber(phoneNumber)) return true
  if (!sex) return true
  return false
}

export const hasChanges = (currentUser, originalUser) => {
  return Object.keys(validateBeneficiaryFields).some((field) => {
    return currentUser[field] !== originalUser[field]
  })
}

const handleValidEmail = (value) => {
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w\w+)+$/
  if (value.length === 0 || value === '') {
    return true
  } if (reg.test(value) === false) {
    return true
  } if (reg.test(value) === true) {
    return false
  }
  return false
}

function verifyEmail(email) {
  if (!email || email.length === 0) return false
  return !email || handleValidEmail(email) ? 'Email Inválido' : false
}
function verifyPhoneNumber(phoneNumber) {
  if (!phoneNumber) return 'É necessário preencher o campo de Celular'
  let aux
  if (phoneNumber) {
    aux = onlyNumbersMask(phoneNumber)
    return !aux || aux.length < 11 ? 'É necessário preencher completamente o campo de Celular' : false
  }
  return false
}

function verifyName(name) {
  const regex = /^[a-zA-Z]+( [a-zA-Z]+)+$/
  if (!name || name.length === 0) {
    return 'É necessário preencher o campo de nome'
  } if (!regex.test(name)) {
    return 'O nome deve conter pelo menos um nome e um sobrenome'
  }

  return false
}
function verifyCpf(cpf) {
  let aux
  if (cpf) aux = onlyNumbersMask(cpf)

  if (!aux || aux.length === 0 || aux.length < 11) {
    return 'É necessário preencher completamente o campo de CPF'
  }

  if (!isValidCPF(cpf)) return 'CPF inválido'

  return false
}
function verifyBirthdate(birthdate) {
  if (!birthdate || birthdate.length === 0 || birthdate.length < 10) {
    return 'É necessário preencher completamente o campo de data de nascimento'
  }
  if (!isValidDate(birthdate)) {
    return 'É necessário colocar uma data válida'
  }
  if (getDiffTime(birthdate) <= 0 || getDiffTime(birthdate) > 118) {
    return 'Data de nascimento inválida, verifique a data inserida'
  }
  return false
}
function verifyInsuranceNumber(insuranceNumber) {
  return insuranceNumber && insuranceNumber.length > 0 && insuranceNumber.length < 16 ? 'É necessário preencher completamente o campo de número da carteirinha' : false
}

export const validatePasswordsFields = {
  password: verifyPassword,
  newPassword: verifyNewPassword,
  passwordConfirm: verifyPasswordConfirm,
}
function verifyPassword(password, newPassword) {
  if (newPassword && !password) return 'É necessário preencher o campo de senha'
  return false
}
function verifyNewPassword(password, newPassword) {
  if (password && newPassword && password === newPassword) return 'A nova senha deve ser diferente da senha atual'
  if (newPassword && (!(/[A-Z]/.test(newPassword)) || !(/\d/.test(newPassword)) || !(/[\W_]/.test(newPassword)) || (newPassword.length < 8 && newPassword.length > 0))) {
    return 'A senha não cumpre os requisitos'
  }
  return false
}

function verifyPasswordConfirm(newPassword, passwordConfirm) {
  if (!passwordConfirm && newPassword && newPassword.length > 0) return 'É necessário preencher o campo de confirmação de senha'
  return newPassword !== passwordConfirm ? 'As senhas não coincidem' : false
}

export const invalidPasswords = (password, newPassword, passwordConfirm) => {
  if (verifyNewPassword(password, newPassword)) return true
  if (verifyPasswordConfirm(newPassword, passwordConfirm)) return true
  if (!password || !newPassword || !passwordConfirm) return true
  return false
}

export const validateForgotPasswordsFields = {
  newPassword: verifyNewPasswordForgotPassword,
  passwordConfirm: verifyPasswordConfirm,
}

function verifyNewPasswordForgotPassword(newPassword) {
  if (newPassword && (!(/[A-Z]/.test(newPassword)) || !(/\d/.test(newPassword)) || !(/[\W_]/.test(newPassword)) || (newPassword.length < 8 && newPassword.length > 0))) {
    return 'A senha não cumpre os requisitos'
  }
  return false
}

export const invalidPasswordsForgotPassword = (newPassword, passwordConfirm) => {
  if (verifyPasswordConfirm(newPassword, passwordConfirm)) return true
  if (!newPassword || !passwordConfirm) return true
  if (newPassword && (!(/[A-Z]/.test(newPassword)) || !(/\d/.test(newPassword)) || !(/[\W_]/.test(newPassword)) || (newPassword.length < 8 && newPassword.length > 0))) {
    return 'A senha não cumpre os requisitos'
  }
  return false
}

export const validateEmailRecoverPassword = {
  email: verifyEmail
}
